import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { getQueryString } from "pages/search/api/filterUrlMaker";
import { _t } from "app/i18n/i18n";
import { onFilterChange } from "./AnalystFilters";
import { SearchButton } from "pages/search/searchBar/SearchButton";

export const AnalystSearchBox = () => (
  <InputGroup size="sm">
    <Form.Control
      as="input"
      type="search"
      onChange={onFilterChange}
      name="q"
      defaultValue={getQueryString().q}
      size="sm"
      placeholder={_t("Search")}
      className="ml-auto maxw-250"
    />
    <InputGroup.Append>
      <SearchButton disabled />
    </InputGroup.Append>
  </InputGroup>
);
